import angular from 'angular';
import { datePickerComponent } from './datePickerComponent';
import 'components/sharpr/date/dateFormat/dateFormatModule';
import 'components/sharpr/detectFocus/detectFocusModule';
import 'components/sharpr/neatSelect/neatSelectModule';
import 'components/sharpr/input/icon/inputIconModule';

angular
	.module('sh.datePicker', ['sh.dateFormat', 'sh.detectFocus', 'sh.neatSelect', 'sh.inputIcon'])
	.component('shDatePicker', datePickerComponent());
